import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Profile {
  readonly playerId: string;
  readonly name: string;
  readonly token: string;
}

interface ProfileStore {
  readonly profile: Profile | null;
  setProfile(profile: Profile | null): void;
  clearProfile(): void;
}

export const useProfileStore = create<ProfileStore>()(
  persist(
    (set) => ({
      profile: null,
      setProfile(profile) {
        set({ profile });
      },
      clearProfile() {
        set({ profile: null });
      },
    }),
    { name: 's4k:profile' },
  ),
);
